namespace Cfnc {
    "use strict";

    interface ICfncTooltip extends ng.IDirective {

    }

    CfncTooltip.$inject = ["$window"];
    function CfncTooltip($window: ng.IWindowService): ICfncTooltip {
        return {
            restrict: "A",
            link: link,
            scope: {
                bsTitle: "@"
            }
        }

        function link(scope, element: ng.IAugmentedJQuery, attrs) {

            if (scope.bsTitle) {
                element.removeAttr("data-bs-title");
                element.attr("data-bs-title", scope.bsTitle);
            }

            new $window.bootstrap.Tooltip(element);
        }
    }

    angular.module("app").directive("cfncTooltip", CfncTooltip);
}